import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { EQueryResponse } from '../../models/e-query-response';
import { EQueryCCQuestion } from '../../../admin/e-query/models/e-query-c-c-question';
import { EQuerySubmittedResponse } from '../../models/e-query-submitted-response';
import { EQueryAttachment } from '../../models/e-query-attachment';
import { OpenQuestionsComponent } from '../open-questions/open-questions.component';
import { ActivityLogger } from '../../../activities/activity-logger';

@Component({
    selector: 'external-user-e-query-content-block',
    template: require('./external-user-e-query-content-block.component.html'),
    styles: [require('./external-user-e-query-content-block.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ExternalUserEQueryContentBlockComponent {
    @ViewChild(OpenQuestionsComponent)
    public openQuestionComponent: OpenQuestionsComponent;

    @Output()
    public submitResponse = new EventEmitter<EQueryResponse>();
    
    @Output()
    public close = new EventEmitter();

    @Output()
    public previewResponseAttachment = new EventEmitter<number>();
    @Output()
    public downloadResponseAttachment = new EventEmitter<number>();

    @Output()
    public downloadAttachment = new EventEmitter<number>();
    @Output()
    public previewAttachment = new EventEmitter<number>();
    
    @Input()
    public accessionData: any;
    @Input()
    public screenResultUrl: any;
    @Input()
    public questions: EQueryCCQuestion[];
    @Input()
    public submittedResponses: EQuerySubmittedResponse[];
    @Input()
    public shouldBeResponded: boolean;
    @Input()
    public attachments: EQueryAttachment[];
    @Input()
    public comments: string;
    @Input()
    public status: string;
    @Input()
    public disableSubmit: boolean;

    public get canSubmit(): boolean {
        return !this.disableSubmit
            && this.openQuestionComponent.editorForm
            && this.openQuestionComponent.editorForm.valid
            && this.openQuestionComponent.wasAtLeastOneResponseAdded;
    }

    constructor(private readonly activityLogger: ActivityLogger) {}

    public submit() {
        const response: EQueryResponse = this.openQuestionComponent.createEQueryResponse();
        this.submitResponse.emit(response);
        this.sendRespondActivity();
    }

    private sendRespondActivity() {
        this.activityLogger.logActivity('Site Responds via Free Text');
    }
}
